import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import ZasadyRachunkowosciStyle from '../../styles/ZasadyRachunkowosciStyle'
import PrintText from '../../lib/PrintText'

export default function ZakresDzialalnosciDM(props) {
  return (
    <ZasadyRachunkowosciStyle>
      <ExpandablePanel title="WSKAZANIE ZAKRESU DZIAŁALNOŚCI DOMU MAKLERSKIEGO WYNIKAJĄCEGO Z UDZIELONYCH ZEZWOLEŃ KOMISJI NADZORU FINANSOWEGO">
        <form autoComplete="off" className="subsection">
          {props.czyPodsumowanie ? (
            <PrintText
              text={props.data.ZakresDzialalnosciDM}
            />
          ) : (
            <TextField
              error={controlHasError(
                props.errors,
                'ZakresDzialalnosciDM',
                props.data.Opis,
              )}
              name="ZakresDzialalnosciDM"
              label="Zakres działalności"
              multiline
              variant="outlined"
              title={props.data.ZakresDzialalnosciDM}
              defaultValue={props.data.ZakresDzialalnosciDM}
              onBlur={(e) =>
                props.onSetSectionData('ZakresDzialalnosciDM', e.target.value)
              }
            />
          )}
        </form>
      </ExpandablePanel>
    </ZasadyRachunkowosciStyle>
  )
}
